/**
 * create-aggregator-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { StdVariable } from "../../../aggregation/typed-parameter";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The {@link CreateAggregatorResponse} signals the successful creation of a
 * new aggregation agent on the server, as well as providing a list of options
 * available to user for configuring and executing the aggregator.
 */
@validateFor(MessageTag.RSP_CREATE_AGGREGATOR)
export class CreateAggregatorResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_CREATE_AGGREGATOR;

  @validateOpaqueID()
  public aggregationId : number;

  @validateAs({array: "object"})
  public targetVariableOptions : StdVariable[];

  @validateAs({array: "object"})
  public filterOptions : StdVariable[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/create-aggregator-response.ts